import styled, { css } from 'styled-components';
import { color } from '../../Assets/color';
import { fonts } from '../../Assets/fonts';

const StyledButton = css`
    border-radius: 100px;
    background-color: ${props => {
        if (props.scratch) {
            return 'transparent';
        }
        return 'rgba(239, 240, 242, 0.3)';
    }};

    background-color: ${props => (props.background ? props.background : 'rgba(239, 240, 242, 0.3)')}

    font-family: ${fonts('normal')};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    margin: 0;

    text-transform: ${props => {
        if (props.scratch) {
            return null;
        }

        return 'uppercase';
    }};

    color: ${color('white')};

    padding: ${props => (props.padding ? props.padding : '14px 30px')};
    border: none;

    outline: none;

    &:hover {
        cursor: pointer;
    }

    &:disabled {
        color: rgba(255, 255, 255, 0.5);
        cursor: default;
        background-color: rgba(239, 240, 242, 0.04);
    }

    &:disabled p {
        opacity: 0.3;
    }

    & a {
        color: #ffffff;
    }
`;

export const Button = styled.button`
    ${StyledButton};
`;

export const LinkButton = styled.span`
    ${StyledButton};
    display: block;
`;

export const RedTextButton = styled.button`
    height: 23px;
    border-radius: 100px;
    border: none;
    text-transform: uppercase;
    font-size: 12px;
    color: #fb4a52;
    font-weight: 500;
    padding: 0 16px;
    cursor: pointer;
    background: #fff;
    outline: none;
    transition: all 0.2s ease;

    &:hover {
        opacity: 0.75;
    }

    &:disabled {
        pointer-events: none;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/UI/Button.js